import http from '../http_v2'

let getEhrOrgList = (data) => {
  return http.get('opservice/sea/corp', data)
}

let getEhrOrgFlag = (data) => {
  return http.get('opservice/sea/crop_ehr', data)
}

let getPersonList = (data) => {
  return http.get('opservice/sea/psn', data)
}

let relationEhrOrg = (data) => {
  return http.post('opservice/org/set_sea', data)
}

let cannelEhrOrg = (data) => {
  return http.post('opservice/org/unset_sea', data)
}
let lookCardDetail = (data) => {        //查看公司卡片详情
  return http.get('opservice/card/v2/org', data)
}
let saveCardSetting = (data) => {     //设置公司卡片详情
  return http.post('opservice/card/v2/org', data)
}
let formList = (data) => {     //留资设置内下拉框
  return http.post('formbuilder/applyform/page', data)
}
export default {
  ehr: {
    psnList: getPersonList,
    orgList: getEhrOrgList,
    orgFlag: getEhrOrgFlag,
    relationOrg: relationEhrOrg,
    cannelEhrOrg: cannelEhrOrg,
    businessDetail: lookCardDetail,
    saveCardSetting: saveCardSetting,
    formList: formList,
  },
  org: {
    tree: (params) => {
      return http.post('opservice/org/tree')
    }
  },
  getEnterpriseInfo: 'opservice/enterprise/info', //查询企业基本信息
  saveEnterpriseInfo: 'opservice/enterprise/save', //保存企业基本信息
  getOrgs: 'opservice/org/tree', // 根据级数获取组织
  addOrg: 'opservice/org/create', // 创建组织
  updateOrg: 'opservice/org/update', // 更新组织
  deleteOrg: 'opservice/org/delete', // 删除组织
  findOneOrg: 'opservice/org/findone', // 获取单个组织信息
  childsOrg: 'opservice/org/childs', // 获取组织机构节点数据
  addPeronOrg: 'opservice/enterpriseadmin/assignOrgs',//给人员增加机构数据
  updatePerson: 'opservice/enterpriseadmin/update', // 更新人员信息
  changePassword: 'opservice/enterpriseadmin/changePasswd',//修改账号密码
  certification: 'opservice/org/set_contacts', //留资设置
  getcertification:'opservice/org/get_contacts?orgId=',
  changeOrg: '/opservice/enterpriseadmin/changeOrg'
}
